import React from 'react';
import styled from 'styled-components';
import { Switch } from '@producer/ui-kit';

const cycles = {
  month: false,
  year: true,
};

type PlanCycleSwitchProps = {
  cycle: 'month' | 'year';
  setCycle: (cycle: 'month' | 'year') => void;
};

export const PlanCycleSwitch: React.FC<PlanCycleSwitchProps> = ({ cycle = 'year', setCycle }) => {
  const handleToggle = (value: boolean) => {
    if (value) {
      setCycle('year');
    } else {
      setCycle('month');
    }
  };

  return (
    <Container>
      <p>Monthly</p>

      <Switch onToggle={handleToggle} isToggled={cycles[cycle]} size="medium" grayscale />

      <p>Yearly</p>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;
`;
